/**
* View prototype
**/
class View {

  /**
  * View class constructor  
  * @constructor
  * @param {Int|String} id - unique controller id
  **/
  constructor(id) {
    this.id = id;
    this.active = false;
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    this.active = false;
  }
  /**
  * prepare (before show)
  **/
  prepare(container) {
  }
  /**
  * animate in (show)
  **/
  show(container) {
    this.active = true;
  }
  /**
   * images loading start
   * fired only if ControllerImgLoad is used
   */
  loadImagesStart(container) {
  }
  /**
   * images loading complete
   * fired only if ControllerImgLoad is used
   */
  loadImagesComplete(container) {
  }  
}

export default View;